import _ from "lodash";
import { toast } from "react-toastify";
import { log } from "../../Helper";
import {
  CustomToolTipDownload,
  CustomToolTipMulti,
  CustomToolTipUrgentOrders,
  CustomTooltip,
} from "../utility/tooltip";
import { providerOrdersURL } from "../utility/constants";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT, REST_URL } from "../../constants/constants";
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';

export async function getProvidersOrders(supplierId, pageSize, pageNumber) {
  let url =
    providerOrdersURL +
    supplierId +
    `/` +
    pageNumber +
    `/` +
    pageSize +
    `/` +
    "sort" +
    `/` +
    "desc";

    const requestOptions = {
      method: "GET",
      headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
      },
    };

  const notifySuccess = (message) => {
    toast.success(message);
  };

  const documentsToDownload = (linkArray) => {
    for (let i = 0; i < linkArray.length; i++) {
      let url = '';

      if (!linkArray[i].href.includes(REST_URL)) {
        url = REST_URL + linkArray[i].href; 
      } else {
        url = linkArray[i].href;
      }

      window.opener = null;
      let myWindow = window.open(
        url,
        "",
        "width=200, height=100"
      );
      setTimeout(() => {
        myWindow.close();
      }, 1500);
    }
    notifySuccess("All documents are downloaded successfully");
  };

  const response = await fetch(url, requestOptions);
  log("after fetch");
  log(response);
  const result = await response.json();
  const tabledata = result.data.pickupPage.content.map((order) => {
    if (result) {
      // Order color
      if (order.color === "GREY") {
        order.buildId = CustomTooltip(
          !_.isEmpty(order.statusText) ? order.statusText : "",
          "#919191",
          "M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z"
        );
      } else if (order.color === "YELLOW") {
        order.buildId = CustomTooltip(
          !_.isEmpty(order.statusText) ? order.statusText : "",
          "#ffde00",
          "M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z"
        );
      } else if (order.color === "RED") {
        order.buildId = CustomTooltip(
          !_.isEmpty(order.statusText) ? order.statusText : "",
          "#FF0000",
          "M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z"
        );
      } else if (order.color === "WARN") {
        order.buildId = CustomTooltip(
          !_.isEmpty(order.statusText) ? order.statusText : "",
          "#FF0000",
          "M24 42q-1.45 0-2.475-1.025Q20.5 39.95 20.5 38.5q0-1.45 1.025-2.475Q22.55 35 24 35q1.45 0 2.475 1.025Q27.5 37.05 27.5 38.5q0 1.45-1.025 2.475Q25.45 42 24 42Zm-3.5-12V6h7v24Z"
        );
      } else if (order.color === "URG") {
        order.buildId = <CustomToolTipUrgentOrders data={!_.isEmpty(order.statusText) ? order.statusText : ""}></CustomToolTipUrgentOrders> 
      }

      //multiforwarder
      if (order.orderType === "MULTI") {
        order.orderType = CustomToolTipMulti();
      } else if (order.orderType === "SINGLE") {
        order.orderType = "";
      }

      // if (order.links.length > 0) {
      //   if (order.links[0].rel) {
      //     let link = order.links;
      //     order.links = (
      //       <a onClick={() => documentsToDownload(link)}>
      //         <CustomToolTipDownload />
      //       </a>
      //     );
      //   }
      // }
    }
    return order;
  });
  // Return the entire response object including pickupPage, locationList, and IMOList
  return {
    pickupPage: {
      ...result.data.pickupPage,
      content: tabledata,
    },
    locationList: result.data.locationList,
    imolist: result.data.imolist,
  };
}



export async function requestLoadBuild(reqObj, acceptedFiles) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/loadBuild`;
  let formData = new FormData();
  console.log("reqObj", reqObj);
  formData.append(
    "jsonBodyData",
    new Blob([JSON.stringify(reqObj)], {
      type: "application/json",
    })
  );

  log("file selected", acceptedFiles);

  for (let i = 0 ; i < acceptedFiles.length ; i++) {
    formData.append("file", acceptedFiles[i]);
  }

  const requestOptions = {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
    },
  };

  const response = await fetch(url, requestOptions);

  return response;
}